module.exports = __webpack_public_path__ + "static/media/font_regular.934effca.woff2";